<template>
  <div>
    <div class="left1">
      <img :src="loginImg" width="100%">
    </div>
    <div style="text-align: center; width: 100%; line-height: 0.5rem; font-size: 0.15rem;">找回密码</div>
    <el-row>
      <el-col :span="6" :offset="9">
        <el-form :model="form" :rules="rules" ref="findPass" size="small">
          <el-form-item label="展商名称：" prop="atrName">
            <el-input v-model.trim="form.atrName" placeholder="请输入展商名称"></el-input>
          </el-form-item>
          <el-form-item label="手机号：" prop="mobile">
            <el-input v-model.trim="form.mobile" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :style="buttonStyle" @click="onSubmit" :disabled = 'saveBtnStatue'>找回密码</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import api from '@/api'
import { validateEnCompany } from '@/utils/validator'
import tools from '../utils/tools.js';
import loginImg from '@/assets/banner.png'
export default {
  data: () => ({
    saveBtnStatue:false,  //保存铵钮状态
    visible:true,
    loginImg:loginImg,
    form: {
     mobile:'',
     sign:'中国国际家纺展',
     atrName:'',
     exhId: localStorage.getItem('ExhID')
    },
    rules: {
      mobile: [{ required: true, message: '请填写手机号', trigger: 'change' }]
    },
    buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {}
  }),


  components: {},
  mounted() {
  },
  methods: {

    onSubmit(){
        if( this.saveBtnStatue ){
          return false
        }
        this.$refs['findPass'].validate((valid) => {
          if (valid) {
              api.findpwd(this.form).then((res) => {
                if (res.data.code === 200) {
                  this.$notify({
                    title: '发送成功！',
                    type: 'success',
                     duration: 2000
                  })
                  this.$router.push('/login?ExhID='+localStorage.getItem("ExhID"))
                }
                this.saveBtnStatue = false
              })
          } else {
            this.$notify({
              title: '请检查表单填写项是否符合规范！',
              type: 'error'
            })
            return false
          }
        })
    }
  }
}
</script>
<style lang="less">

</style>
